import React, { FC, useEffect, useState } from 'react';
import { Flex, Stack, Text } from '@chakra-ui/react';
import { api, makeHeaders } from '../../util/api';
import { useFetch } from 'use-http';
import { isSafe } from '../../util/array';
import { useNavigate } from 'react-router';
import { ERROR_MESSAGE, useNotify } from '../../hooks/useNotify';
import { Link } from 'react-router-dom';
import { Survey } from '../../components/Survey/types';
import Loading from '../../components/Misc/Loading';
import SurveyCard from '../../components/Survey/SurveyCard';
import { useDialog } from '../../hooks/useDialog';

const SurveyPage: FC = () => {
  const {
    createDialog,
    closeDialog,
    setLoading: setDialogLoading,
  } = useDialog();

  const navigate = useNavigate();
  const [surveys, setSurveys] = useState<Survey[]>([]);
  const notify = useNotify();

  const {
    get,
    del,
    cache,
    response,
    loading,
    error,
  } = useFetch(`${api}/surveys`, makeHeaders());

  const refreshSurveys = async () => {
    cache.clear();
    const surveys = await get();
    if (response.ok && isSafe(surveys, error)) {
      setSurveys(surveys);
    } else {
      notify(ERROR_MESSAGE, 'error');
    }
  };

  const editSurvey = (id: string) => {
    navigate(`/encuestas/${id}/editar`);
  };

  const deleteSurvey = async (id: string) => {
    try {
      setDialogLoading(true);
      cache.clear();
      await del(`/${id}`);
      if (!error && response.ok) {
        notify('Encuesta archivada', 'success');
        refreshSurveys();
      } else {
        throw new Error();
      }
    }
    catch (error) {
      notify(ERROR_MESSAGE, 'error');
    }
    finally {
      setDialogLoading(false);
      closeDialog();
    };
  }

  const deleteHandler = (id: string) => {
    createDialog({
      title: 'Borrar encuesta',
      content: '¿Estás seguro que deseas borrar esta encuesta?',
      onConfirm: () => deleteSurvey(id),
      onCancel: closeDialog,
      confirmText: 'Sí, borrar',
    });
  };

  useEffect(() => {
    refreshSurveys();
  }, []); // eslint-disable-line

  return (
    <Stack maxW='container.xl' mx={3} mb={2}>
      <Loading isLoading={loading} />
      {!surveys.length && (
        <Text fontSize='sm' fontWeight='medium' color='gray.500' textAlign='center'>
          {loading && 'Cargando...'}
          {!loading && 'No hay encuestas.'}
        </Text>
      )}
      <Flex gap={6} flexWrap='wrap'>
        {surveys.map((survey) => (
          <Link to={`/encuestas/${survey.id}`} key={survey.id} >
            <SurveyCard
              id={survey.id}
              title={survey.title}
              status={survey.status}
              responses={survey.responses}
              createdAt={survey.createdAt}
              onClick={() => editSurvey(survey.id)}
              onDelete={() => deleteHandler(survey.id)}
            />
          </Link>
        ))}
      </Flex>
    </Stack>
  )
};

export default SurveyPage;
